import {Casing} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/TextFormat/components/Casing/Casing';
import {Alignment} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/TextFormat/components/Alignment/Alignment';

import './TextFormat.sass';

export const TextFormat = () => (
  <div className="text-format create-flow__texteditor-content">
    <Casing className="text-format__upper" />
    <Alignment className="text-format__lower" />
  </div>
);
